import React, { useRef, useEffect } from "react";
import { motion } from "framer-motion";
import emailjs from "@emailjs/browser";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../styles/Contactpage.css";
import Beams from "./Beams";

const ContactPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const formDubaiRef = useRef();
  const formAbuDhabiRef = useRef();

  const sendEmail = (e, formRef, locationName) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_wanv8rl",        // ✅ Your Service ID
        "template_rp0km0k",       // ✅ Same Template ID for both
        formRef.current,
        "Ybkgi8RjqCHw5yfwS"        // ✅ Your Public Key
      )
      .then(
        () => {
          toast.success(`Message regarding ${locationName} sent successfully!`);
          formRef.current.reset();
        },
        (error) => {
          console.error("EmailJS Error:", error);
          toast.error(
            `Failed to send message for ${locationName}. Please try again.`
          );
        }
      );
  };

  return (
    <div className="contact-container">
      
      {/* Background Animation */}
      <div className="elec-installation-silk-bg">
        <Beams
          beamWidth={1.4}
          beamHeight={30}
          beamNumber={14}
          lightColor="#00CCFF"
          speed={20}
          noiseIntensity={0}
          scale={0.19}
          rotation={59}
        />
      </div>

      <div className="contact-overlay" />

      <ToastContainer position="top-right" autoClose={3000} />

      <div className="contact-content-wrapper">

        {/* ===================== DUBAI FORM ===================== */}
        <motion.div
          className="contact-form-column"
          initial={{ opacity: 0, x: -50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          <div className="contact-form-container">
            <h2 className="form-location-heading">For Dubai, UAE</h2>
            
            <form
              ref={formDubaiRef}
              onSubmit={(e) => sendEmail(e, formDubaiRef, "Dubai")}
              className="contact-form"
            >
              <input type="hidden" name="form_location" value="Dubai, UAE" />

              <label>Name</label>
              <input type="text" name="name" required />

              <label>Email</label>
              <input type="email" name="email" required />

              <label>Message</label>
              <textarea name="message" rows="5" required />

              <button type="submit">Send to Dubai</button>
            </form>
          </div>
        </motion.div>

        {/* ===================== CENTER CONTENT ===================== */}
        <motion.div
          className="contact-center-column"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <div className="contact-center-content">
            <h1>Get in Touch</h1>
            <p>
              Whether you have a question or a project in mind,
              reach out and let's connect.
            </p>
          </div>
        </motion.div>

        {/* ===================== ABU DHABI FORM ===================== */}
        <motion.div
          className="contact-form-column"
          initial={{ opacity: 0, x: 50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          <div className="contact-form-container">
            <h2 className="form-location-heading">For Abu Dhabi, UAE</h2>
            
            <form
              ref={formAbuDhabiRef}
              onSubmit={(e) => sendEmail(e, formAbuDhabiRef, "Abu Dhabi")}
              className="contact-form"
            >
              <input
                type="hidden"
                name="form_location"
                value="Abu Dhabi, UAE"
              />

              <label>Name</label>
              <input type="text" name="name" required />

              <label>Email</label>
              <input type="email" name="email" required />

              <label>Message</label>
              <textarea name="message" rows="5" required />

              <button type="submit">Send to Abu Dhabi</button>
            </form>
          </div>
        </motion.div>

      </div>
    </div>
  );
};

export default ContactPage;